import { useEffect, useState } from 'react'
export function useDebouncedValue<T>(value: T, delay: number) { const [debounced,setDebounced] = useState(value); useEffect(() => { const timer = window.setTimeout(() => setDebounced(value), delay); return () => window.clearTimeout(timer) }, [value,delay]); return debounced }


